module.exports = __webpack_public_path__ + "static/media/auth.44969a74.svg";